import { AnalyticsBrowser } from '@segment/analytics-next';
import { of } from 'rxjs';
import { catchError, shareReplay, tap } from 'rxjs/operators';

import { throwClientLoadingError } from './analytics.errors';
import type {
  SegmentAPIMethods,
  SegmentClientIdentifyCallbackFn,
  SegmentClientOptions,
} from './analytics.types';

export const loadAnalytics = (segmentKey: string, options?: SegmentClientOptions) => {
  const client = AnalyticsBrowser.load({ writeKey: segmentKey }, options);
  return of(segmentAdapter(client)).pipe(
    catchError(() => throwClientLoadingError()),
    tap((_client: any) => {
      _client.addDestinationMiddleware('Intercom', ({ payload, next }: any) => {
        const type = payload.obj.type;

        if (type === 'identify') {
          delete payload.obj.traits.id;
          delete payload.obj.id;
          delete payload.obj.userId;

          payload.obj.email = payload.obj.traits.email;
        }

        next(payload);
      });
    }),
    shareReplay(1),
  );
};
const segmentAdapter = (input: AnalyticsBrowser): SegmentAPIMethods => ({
  ...input,
  identify: (
    userId?: number,
    traits?: Record<string, string | number>,
    options?: SegmentClientOptions,
    callback?: SegmentClientIdentifyCallbackFn,
  ) => {
    input.identify(`${userId}`, traits, options, callback);
  },
});
